import { Box, Button, Radio, RadioGroup, Stack, Text } from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

import { Reason, ReportReason } from './types';

/**
 * The report form content, decoupled from any surrounding chrome. These pieces
 * render with plain Bokeh primitives (no Modal subcomponents, which throw
 * outside a `<Modal />`), so they can be composed into either the modal shell
 * (`ReportModal`) or the full-page shell (`ReportPanel`).
 */

export interface ReportReasonListProps {
  cta: string;
  reasons: ReportReason[];
  reportReason: Reason;
  setReportReason: (value: Reason) => void;
}

export const ReportReasonList = ({
  cta,
  reasons,
  reportReason,
  setReportReason,
}: ReportReasonListProps) => {
  return (
    <>
      <Text variant="body-xl" fontWeight="medium" mb="200">
        {cta}
      </Text>
      <RadioGroup onChange={setReportReason} value={reportReason}>
        <Stack spacing={200}>
          {reasons.map((reason) => (
            <Box key={reason.title}>
              <Radio value={reason.value}>
                <Text variant="body-md">{reason.title}</Text>
              </Radio>
              <Text variant="body-md" pl="300" color="text-secondary">
                {reason.description}
              </Text>
            </Box>
          ))}
        </Stack>
      </RadioGroup>
    </>
  );
};

export interface ReportActionsProps {
  isSubmitDisabled: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const ReportActions = ({ isSubmitDisabled, onClose, onSubmit }: ReportActionsProps) => {
  return (
    <>
      <Text flex="1" variant="body-md" textDecor="underline">
        <a href={'/help/guidelines'}>{translate('Learn more')}</a>
      </Text>
      <Button variant="tertiary" size="md" onClick={onClose}>
        {translate('Cancel')}
      </Button>
      <Button variant="primary" size="md" onClick={onSubmit} isDisabled={isSubmitDisabled}>
        {translate('Report')}
      </Button>
    </>
  );
};
